import type React from 'react';
import { useFormContext } from 'react-hook-form';

import type { VNFieldHelpProps } from '@/components/VNFieldHelp';
import { VNFieldHelpHeading } from '@/components/VNFieldHelp';

import VNSwitch from '../VNSwitch/VNSwitch';

type Props = VNFieldHelpProps & {
  title?: string | React.ReactNode;
  actions?: React.ReactNode;
  main?: boolean;
  description?: string;
  className?: string;
  style?: React.CSSProperties;
  children: React.ReactNode;
  enableSwitch?: string;
  disabledSwitch?: boolean;
  subPortlet?: boolean;
};

const VNPortlet = ({
  title = '',
  actions,
  main = false,
  description = '',
  className = '',
  style,
  children,
  enableSwitch,
  disabledSwitch = false,
  subPortlet = false,
  ...fieldHelpProps
}: Props) => {
  const methods = useFormContext();
  const watch = methods != null ? methods.watch : null;
  const isEnabled = watch != null && enableSwitch ? watch(enableSwitch) : true;

  return (
    <div
      className={`vn-portlet ${className} ${isEnabled ? 'portlet-enabled' : ''} ${subPortlet ? 'sub-portlet' : ''}`}
      style={style}
    >
      {!main && title && (
        <div className="portlet-header">
          <div className="portlet-title">
            <VNFieldHelpHeading title={title} {...fieldHelpProps} />
            {description && <h3>{description}</h3>}
          </div>
          {actions && <div className="portlet-actions">{actions}</div>}
          {enableSwitch && (
            <div className="portlet-actions">
              <VNSwitch name={enableSwitch} label="" disabled={disabledSwitch} />
            </div>
          )}
        </div>
      )}
      {main && (
        <div className="main-title">
          <VNFieldHelpHeading title={title} {...fieldHelpProps} />
        </div>
      )}
      {isEnabled && <div className="portlet-container">{children}</div>}
    </div>
  );
};

export default VNPortlet;
